import { useState, useEffect } from "react";

import apiCall from "../../utilities/auth/apiCall";
import { assessmentAddSummary } from "../../utilities/auth/authApi";
import { reportError } from "../../../functions/sentry";
import generateAssessmentSummary from "../../../functions/generateAssessmentSummary";
import { systemMessages } from "../../../variables/systemMessages";

import AssessmentSummaryDetails from "./assessmentSummaryDetails";
import LoadingBasic from "../../utilities/loadingbasic";


function AssessmentSummary(props) {

  // Define variables
  const [summary, setSummary] = useState(null);
  const [generating, setGenerating] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const score = props.score;
  const code = props.code;


  // Component load actions
  useEffect(() => {
    if( score.summary ) {
      setSummary(score.summary);
    } else {
      setGenerating(true);
      const payload = score;

      generateAssessmentSummary(payload).then((response) => {
        if( response.success ) {
          const summaryData = response.data;
          setSummary(summaryData);

          // TO DO - save summary on server
          const payload = {
            code: code,
            summary: summaryData
          };

          apiCall(assessmentAddSummary, payload).then((response) => {
            // Do nothing
          });

        } else {
          reportError(response.error, 'Assess Summary - generate')
          setErrorMessage(systemMessages.summaryError);
        }

        setGenerating(false);
      });
    }
  }, []);


  // Screen components
  let bodyElement;
  if( summary ) {
    bodyElement = <AssessmentSummaryDetails summary={summary} />;
  } else {
    if( generating ) {
      bodyElement = (
        <div class='flex-column'>
          <LoadingBasic wording={'Generating summary ...'} />
        </div>
      );
    } else if( errorMessage ) {
      bodyElement = <p style={{marginTop: '15px'}}><i>{errorMessage}</i></p>;
    }
  }


  return (
    <div class='flex-column assess-score-section'>
      <p class='assess-fancy'>Summary</p>
      {bodyElement}
    </div>
  );

}

export default AssessmentSummary;